import { gsap } from 'gsap';
import EventBus from 'eventing-bus';
import { connect } from 'react-redux';
import { SplitText } from 'gsap/SplitText';
import PhoneInput from 'react-phone-input-2';
import { MsalProvider } from '@azure/msal-react';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Link, useParams } from 'react-router-dom';
import React, { useEffect, useState, useRef } from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { PublicClientApplication } from '@azure/msal-browser';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';

import './index.css';
import { onSignUp } from '../../store/Auth';
import { getBranding } from '../../store/Settings';
import logo from '../../static/img/logo.png';
import { oauthConfig } from '../../store/config';
import SocialLogin from '../../components/SocialLogin';

gsap.registerPlugin(SplitText, ScrollTrigger);
// Initialize MSAL instance for Microsoft authentication
const msalInstance = new PublicClientApplication({
  auth: {
    clientId: oauthConfig['microsoft']['clientId'],
    authority: oauthConfig['microsoft']['authority'],
    redirectUri: oauthConfig['microsoft']['redirectUri'],
  }, cache: { cacheLocation: 'sessionStorage', storeAuthStateInCookie: false }
})

function Signup({ history, onSignUp, isLogin, auth, dispatch, currentBranding }) {
  const { hash } = useParams();
  const headingRefs = useRef([]);
  const paragraphRefs = useRef([]);
  const splitParagraphs = useRef([]);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [formData, setFormData] = useState({ step: 1, email: '', password: '', confirmPassword: '', hash: '', lastName: '', firstName: '', phone: '', privacyPolicy: false });

  useEffect(() => { if (auth) history.push('/dashboard') }, [auth]);
  useEffect(() => { if (hash) setFormData(prevData => ({ ...prevData, step: 2, hash })); }, [hash]);
  useEffect(() => { document.title = 'Sign Up | ' + (currentBranding?.['agencyName']) }, [currentBranding]);

  const handleSingup = () => {
    // Validate additional fields if hash is present
    if (formData['step'] === 2) {
      if (!formData['lastName']) return EventBus.publish('error', 'Last name is required');
      if (!formData['phone']) return EventBus.publish('error', 'Phone number is required');
      if (!formData['firstName']) return EventBus.publish('error', 'First name is required');
      if (!formData['password']) return EventBus.publish('error', 'Password is required');
      if (!formData['confirmPassword']) return EventBus.publish('error', 'Confirm password is required');
      if (formData['password'] !== formData['confirmPassword']) return EventBus.publish('error', 'Passwords do not match');
      if (!formData['privacyPolicy']) return EventBus.publish('error', 'You must accept the Privacy Policy to continue');
    }

    onSignUp({ data: formData, history });
  }

  useEffect(() => {
    // Reset any previous SplitText instances
    splitParagraphs.current.forEach((split) => split?.revert?.());
    splitParagraphs.current = [];

    // Animate each heading
    headingRefs.current.forEach((el, i) => {
      gsap.fromTo(el, { opacity: 0, filter: "blur(10px)", y: -20 }, { opacity: 1, filter: "blur(0px)", y: 0, duration: 0.8, ease: "power3.out", delay: i * 0.3 });
    });

    // Animate each paragraph with SplitText
    paragraphRefs.current.forEach((el, i) => {
      const split = new SplitText(el, { type: "chars" });
      splitParagraphs.current.push(split);

      gsap.fromTo(
        split.chars,
        { opacity: 0, y: 20 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          stagger: 0.02,
          ease: "power2.out",
          delay: (headingRefs.current.length + i) * 0.1,
        }
      );
    });
  }, []);

  return (
    <div className='login-page signup-page'>
      <div className='logo-area'>
        { currentBranding?.['logo'] && <img className='login-page-logo' src={currentBranding?.['logo']} alt={currentBranding?.['agencyName']} /> }
      </div>
      <div className='auto-container'>
        <div className='row'>
          <div className='col-lg-6 col-md-6 col-sm-12 login-area'>
            <div className='left-img-area'>
              <img src={require('../../static/img/signup.png')} alt='' />
             <div className="title-bottom">
                 <h2 ref={(el) => el && headingRefs.current.push(el)}>{currentBranding?.['agencyName']}</h2>
              <p ref={(el) => el && paragraphRefs.current.push(el)}>Welcome to {currentBranding?.['agencyName'] || 'SellAgent'}—automated follow-ups, smart contact scoring,<br />integrated messaging, and real-time analytics in one CRM.</p>
             </div>
            </div>
          </div>
          {formData['step'] === 1 && (
            <div className='col-lg-5 offset-lg-1 col-md-6 col-sm-12 login-area'>
              <div className='login-form'>
                <div className='title-area'>
                  <h2 ref={(el) => el && headingRefs.current.push(el)}>Create your Account</h2>
                  <p ref={(el) => el && paragraphRefs.current.push(el)}>Enter and email and create a password, getting started is easy!</p>
                </div>

                <ValidatorForm className='validator-form mt-2' onSubmit={handleSingup}>
                  <div className='group-form'>
                    <label>Email</label>
                    <TextValidator
                      type='text'
                      name='email'
                      margin='dense'
                      variant='outlined'
                      placeholder='Email here'
                      value={formData['email']}
                      className='login-input-fields'
                      validators={['required', 'isEmail']}
                      errorMessages={['Email can not be empty', 'Email is not valid']}
                      onChange={(e) => setFormData({ ...formData, email: e['target']['value'] })}
                    />
                  </div>
                  <div className='group-form btn-signup text-center'>
                    <button type='submit' className='btn-style-new' disabled={isLogin}>
                      {!isLogin ? 'Verify email' : <div><i className='fa fa-spinner fa-spin'></i></div>}
                    </button>
                  </div>
                </ValidatorForm>
                {!currentBranding?.['isCustom'] && (
                  <>
                    <div className='or-text'>
                      <p>Or Signup With</p>
                    </div>
                    <GoogleOAuthProvider clientId={oauthConfig['google']['clientId']}>
                      <MsalProvider instance={msalInstance}>
                        <SocialLogin history={history} type='Sign up' />
                      </MsalProvider>
                    </GoogleOAuthProvider>
                  </>
                )}

                <div className='group-form checkbox-group'>
                  <p>Have an account? <Link to='/login'>Login</Link></p>
                </div>
              </div>
            </div>
          )}
          {formData['step'] === 2 && (
            <div className='col-lg-6 col-md-6 col-sm-12 login-area'>
              <div className='login-form style-step-two'>
                <h2 ref={(el) => el && headingRefs.current.push(el)}>Create your Account</h2>
                <p ref={(el) => el && paragraphRefs.current.push(el)}>Create a password, getting started is easy!</p>
                <ValidatorForm className='validator-form mt-4' onSubmit={handleSingup}>
                  <div className='row'>
                    <div className='col-lg-6 col-md-6 col-sm-12'>
                      <div className='group-form'>
                        <label>First Name</label>
                        <TextValidator
                          type='text'
                          name='firstName'
                          margin='dense'
                          variant='outlined'
                          validators={['required']}
                          placeholder='First name here'
                          value={formData['firstName']}
                          className='login-input-fields'
                          errorMessages={['First name cannot be empty']}
                          onChange={(e) => setFormData({ ...formData, firstName: e['target']['value'] })}
                        />
                      </div>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12'>
                      <div className='group-form'>
                        <label>Last Name</label>
                        <TextValidator
                          type='text'
                          name='lastName'
                          margin='dense'
                          variant='outlined'
                          validators={['required']}
                          placeholder='Last name here'
                          value={formData['lastName']}
                          className='login-input-fields'
                          errorMessages={['Last name cannot be empty']}
                          onChange={(e) => setFormData({ ...formData, lastName: e['target']['value'] })}
                        />
                      </div>
                    </div>
                    <div className='col-12'>
                      <div className='group-form'>
                        <label>Phone Number</label>
                        <PhoneInput
                          country={'us'}
                          value={formData['phone']}
                          placeholder='Phone number here'
                          containerStyle={{ width: '100%' }}
                          inputStyle={{
                            width: '100%',
                            height: '56px',
                            fontSize: '16px',
                            borderRadius: '4px',
                            border: '1px solid rgba(0, 0, 0, 0.23)'
                          }}
                          onChange={(value) => setFormData({ ...formData, phone: `+${value}` })}
                        />
                      </div>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12'>
                      <div className='group-form password-group'>
                        <label>Password</label>
                        <TextValidator
                          margin='dense'
                          name='password'
                          variant='outlined'
                          validators={['required']}
                          placeholder='Password here'
                          value={formData['password']}
                          className='login-input-fields'
                          type={showPassword ? 'text' : 'password'}
                          errorMessages={['Password cannot be empty']}
                          onChange={(e) => setFormData({ ...formData, password: e['target']['value'] })}
                          InputProps={{
                            endAdornment: (
                              <i
                                onClick={() => setShowPassword(!showPassword)}
                                className={`fa ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}
                                style={{ cursor: 'pointer', position: 'absolute', right: '13px', color: '#757575' }}
                              />
                            ),
                          }}
                        />
                      </div>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12'>
                      <div className='group-form password-group'>
                        <label>Confirm Password</label>
                        <TextValidator
                          margin='dense'
                          variant='outlined'
                          name='confirmPassword'
                          validators={['required']}
                          placeholder='Confirm password'
                          className='login-input-fields'
                          value={formData['confirmPassword']}
                          type={showConfirmPassword ? 'text' : 'password'}
                          errorMessages={['Confirm password cannot be empty']}
                          onChange={(e) => setFormData({ ...formData, confirmPassword: e['target']['value'] })}
                          InputProps={{
                            endAdornment: (
                              <i
                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                className={`fa ${showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'}`}
                                style={{ cursor: 'pointer', position: 'absolute', right: '13px', color: '#757575' }}
                              />
                            ),
                          }}
                        />
                      </div>
                    </div>
                    <div className='col-12'>
                      <div className='group-form privacy-policy'>
                        <div className='privacy-checkbox'>
                          <input
                            type='checkbox'
                            className='mr-2'
                            id='privacyPolicy'
                            checked={formData['privacyPolicy']}
                            onChange={(e) => setFormData({ ...formData, privacyPolicy: e['target']['checked'] })}
                          />
                          <label htmlFor='privacyPolicy'> I accept the <Link to='/privacy-policy'>Privacy Policy</Link></label>
                        </div>
                      </div>

                      <div className='group-form btn-signup text-center'>
                        <button type='submit' className='btn-style-new' disabled={isLogin}>
                          {!isLogin ? 'Signup' : <div><i className='fa fa-spinner fa-spin'></i></div>}

                        </button>
                      </div>
                      <p><Link to='/signup'>Back</Link></p>
                      <div className='group-form checkbox-group'>
                        <p>Have an account? <Link to='/login'>Login</Link></p>
                      </div>
                    </div>
                  </div>

                </ValidatorForm>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

const mapDispatchToProps = dispatch => ({
  onSignUp: data => dispatch(onSignUp(data)),
  dispatch
});
const mapStateToProps = ({ Auth: { isLogin, auth }, Settings: { currentBranding } }) => ({ isLogin, auth, currentBranding });

export default connect(mapStateToProps, mapDispatchToProps)(Signup);